import request from '@core/services/request';

export const plateTransactionsAPI = {
	initiate: (fimenu: any, type: any, revert = false, overrideType: any = null) => {
		return request.post(`/PlateTransactions/Initiate`, {
			fimenu,
			revert,
			type,
		});
	},
	getMissingDocuments: (fimenu: any) => {
		return request.post(`/PlateTransactions/GetMissingDocuments`, fimenu);
	},
	getDealId: (vin: any, storeCode: any) => {
		return request.get(`/PlateTransactions/GetDealId?vin=${vin}&storeCode=${storeCode}`);
	},
	getDocuments: (dealId: any, storeCode: any) => {
		return request.get(`/PlateTransactions/GetDocuments?dealId=${dealId}&storeCode=${storeCode}`);
	},
	getDDIData: (id: any) => {
		// Will get our stored DDI data from elasticsearch. We store Vehicle Inquiries, Transactions with them, etc.
		return request.get(`/PlateTransactions/GetDDIData?id=${id}`);
	},
	vehicleInquiryVin: (vin: any, storeCode: any) => {
		// This is a generic one. In case we need to use and not keep record of.
		return request.get(`/PlateTransactions/VehicleInquiry/vin?vin=${vin}&storeCode=${storeCode}`);
	},
	vehicleInquiryPlate: (plate: any, storeCode: any) => {
		// This is a generic one. In case we need to use and not keep record of.
		return request.get(`/PlateTransactions/VehicleInquiry/plate?plate=${plate}&storeCode=${storeCode}`);
	},
	tradeinVehicleInquiry: (vin: any, dealId: any, storeCode: any) => {
		// This will create an associaion and bind it to the deal.
		return request.get(`/PlateTransactions/TradeinVehicleInquiry?vin=${vin}&dealId=${dealId}&storeCode=${storeCode}`);
	},
	getLastVehicleInquiryVin: (vin: any, storeCode: any) => {
		// Will return the last vehicle inquiry related to this deal.
		return request.get(`/PlateTransactions/GetLastVehicleInquiry/vin?vin=${vin}&storeCode=${storeCode}`);
	},
	getLastVehicleInquiryPlate: (plate: any, storeCode?: any) => {
		// Will return the last vehicle inquiry related to this deal.
		return request.get(`/PlateTransactions/GetLastVehicleInquiry/plate?plate=${plate}&storeCode=${storeCode}`);
	},
	validateCredentialsWithProvider: (username: any, password: any, storeCode: any) => {
		return request.get(`/PlateTransactions/VerifyCredentials?username=${username}&password=${password}&storeCode=${storeCode}`);
	},
	hasCredentials: () => request.get('/PlateTransactions/HasCredentials'),
	cancelDeal: (id: any, fiMenuDealId: any) => request.get(`/PlateTransactions/CancelDeal?id=${id}&fiMenuDealId=${fiMenuDealId}`),
};
